import { render, staticRenderFns } from "./CoolingDeviceWrapper.vue?vue&type=template&id=7c2cb5d5&scoped=true&"
import script from "./CoolingDeviceWrapper.vue?vue&type=script&lang=js&"
export * from "./CoolingDeviceWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2cb5d5",
  null
  
)

export default component.exports